import {
	type FrontendPlacementMessage,
	type FrontendStage,
} from '@post-office/message-maker-browser/types';

import { Targets } from '@atlassiansox/cross-flow-support/cross-flow-base-types';

import { noValidation } from '@post-office/message-maker-browser/message-helpers';

import {
	PlacementFrontend,
	type PlacementRenderProps,
} from '@post-office/browser--growth/atlas-side-nav-growth-item';

import { type ComponentProps } from '@post-office/browser--growth/components/atlas-side-nav-growth-item';

import { AtlasSideNavRecommendationCompass } from './messages/atlas-side-nav-recommendation-compass';

import { AtlasSideNavRecommendationConfluence } from './messages/atlas-side-nav-recommendation-confluence';

import { AtlasSideNavRecommendationJira } from './messages/atlas-side-nav-recommendation-jira';

import { AtlasSideNavRecommendationJpd } from './messages/atlas-side-nav-recommendation-jpd';

import { AtlasSideNavRecommendationJsm } from './messages/atlas-side-nav-recommendation-jsm';

import { AtlasSideNavRecommendationLoom } from './messages/atlas-side-nav-recommendation-loom';

import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';

// This is the Message Frontend. In this Placement we have render.Component which takes a React Component which will render your message in the Placement.
export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: FrontendStage<PlacementRenderProps>;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<ComponentProps>(),

		Component: (props: ComponentProps) => {
			const { targetProduct } = props;
			switch (targetProduct) {
				case Targets.CONFLUENCE:
					return <AtlasSideNavRecommendationConfluence {...props} />;
				case Targets.COMPASS:
					return <AtlasSideNavRecommendationCompass {...props} />;
				case Targets.JIRA_SOFTWARE:
				case Targets.JIRA_CORE:
					return <AtlasSideNavRecommendationJira {...props} />;
				case Targets.JIRA_PRODUCT_DISCOVERY:
					return <AtlasSideNavRecommendationJpd {...props} />;
				case Targets.JIRA_SERVICE_DESK:
					return <AtlasSideNavRecommendationJsm {...props} />;
				case Targets.LOOM:
					return <AtlasSideNavRecommendationLoom {...props} />;
				default:
					return <></>;
			}
		},
	},
});
